// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // cartItemCount: 0,  // 购物车商品数量
    // cartItem: [],
    loginDialogVisiable: false,
    registerDialogVisiable: false,
    // isLogin: false,
  },
  mutations: {
    // updateCartItemCount(state,cartItemCount){
    //   state.cartItemCount = cartItemCount;
    // },
    // updateCartItem(state,cartItem){
    //   state.cartItem = cartItem;
    // },
    updateLoginDialogVisiable(state,loginDialogVisiable){
      state.loginDialogVisiable = loginDialogVisiable;
    },
    updateRegisterDialogVisiable(state,registerDialogVisiable){
      state.registerDialogVisiable = registerDialogVisiable;
    },
    // updateIsLogin(state,isLogin){
    //   state.isLogin = isLogin;
    // }
  },
  actions: {
  },
  getters: {
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js